import { render, staticRenderFns } from "./Motivo.vue?vue&type=template&id=2ff7211e"
import script from "./Motivo.vue?vue&type=script&lang=js"
export * from "./Motivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports